import MathHelper from "./mathHelper";

class NumberFormatter {
  static getCurrencyFormattedNumber(value) {
    if (value === null || value === undefined || value === "") {
      return "";
    }
    if (/^-/.test(this.getFormattedNumber(value))) {
      return this.getFormattedNumber(value).replace("-", "- $");
    }
    return "$" + this.getFormattedNumber(value); // eslint-disable-line prefer-template
  }

  static getFormattedNumber(value) {
    if (value === 0) {
      return "0.00";
    }

    if (!value) {
      return "";
    }

    if (!this.isInt(this.scrubFormatting(value))) {
      return ""; // if it's not a number after scrubbing formatting, just return empty.
    }

    let roundedValue = MathHelper.roundNumber(value, 2); // round if more than 2 decimal points
    roundedValue = roundedValue
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ","); // add commas for 1,000's. RegEx from http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    const roundedValueContainsDecimalPlace = roundedValue.indexOf(".") !== -1;

    if (roundedValueContainsDecimalPlace) {
      const numbersToTheRightOfDecimal = roundedValue.split(".")[1];

      switch (numbersToTheRightOfDecimal.length) {
        case 0:
          return roundedValue.replace(".", ""); // no decimal necessary since no numbers after decimal
        case 1:
          return `${roundedValue}0`;
        default:
          return roundedValue;
      }
    } else {
      roundedValue += ".00";
    }
    return roundedValue;
  }

  static isInt(n) {
    if (n === "" || n === null) {
      return false;
    }

    return n % 1 === 0;
  }

  static scrubFormatting(value) {
    return value
      .toString()
      .replace("$", "")
      .replace(",", "")
      .replace(".", "");
  }

  /**
   * see http://forums.shopify.com/categories/2/posts/29259
   * also https://www.quora.com/Which-is-grammatically-correct-101st-or-101th
   * @param {Number} number
   * @returns {string}
   */
  static ordinalFormat(number) {
    const suffix = ["th", "st", "nd", "rd"];
    const reminder = number % 100;

    return (
      number + (suffix[(reminder - 20) % 10] || suffix[reminder] || suffix[0])
    );
  }

  static forceTwoDecimalPoints(number) {
    return /[0-9]+[.]0?$/.test(number) || // make sure the number is left with only two decimal points without rounding
      /[0-9]+[.][0-9]{1,2}$/.test(number) ||
      /^[.]\d{0,2}$/.test(number) // retain numbers that start with a .
      ? number
      : (number + "" || "").replace(/([.]\d{2})\d+$/, "$1") * 1;
  }

  static roundTwoDecimalPoints(number) {
    return Math.round(number * 100) / 100;
  }

  static forceNotNegativeAndTwoDecimalPoints(number) {
    number = (number + "" || "").replace(/^-/, "");
    return this.forceTwoDecimalPoints(number);
  }
}

export default NumberFormatter;



// WEBPACK FOOTER //
// ./src/utils/numberFormatter.js